import React, { useEffect, useRef } from "react";
import "./Location.css";
import imgDivider from "../../assets/image/img-divider-loc.png";
import gsap from "gsap";
import Arrow from "../../assets/image/arrow-one.png";
import ArrowSecond from "../../assets/image/arrow-two.png";
import CircleSpinner from '../../assets/image/circle-spinner.png';

const Location = () => {
const circleRef = useRef(null); // Ref for the animated element

useEffect(() => {
  const tl = gsap.timeline({ repeat: -1000, yoyo: true });

  tl.to(circleRef.current, {
    y: -600,
    duration: 5,
    ease: "power1.inOut",
  })
    .to(circleRef.current, {
      opacity: 0,
      // visibility: 'hidden', // Mengatur opacity menjadi 0
      duration: 1,
      // delay: .1, // Delay sebelum opacity diubah menjadi 0
    })
    .to(circleRef.current, {
      y: 0, // Mengembalikan posisi gambar ke awal
      opacity: 0,
      // visibility: 'visible', // Mengembalikan opacity ke 1
      duration: 5,
      // delay: .2,
      onComplete: () => {
        tl.play(0); // Mulai ulang animasi
      },
    });
}, []);

const circleRefs = useRef(null); // Ref for the animated element

useEffect(() => {
  const tl = gsap.timeline({ repeat: -1000, yoyo: true });

  tl.to(circleRefs.current, {
    y: -500,
    duration: 5,
    ease: "ease-in-out",
  })
    .to(circleRefs.current, {
      opacity: 0,
      // visibility: 'hidden', // Mengatur opacity menjadi 0
      duration: 1,
      // delay: .1, // Delay sebelum opacity diubah menjadi 0
    })
    .to(circleRefs.current, {
      y: 0, // Mengembalikan posisi gambar ke awal
      opacity: 0,
      // visibility: 'visible', // Mengembalikan opacity ke 1
      duration: 5,
      //  delay: 0.2,
      onComplete: () => {
        tl.play(0); // Mulai ulang animasi
      },
    });
}, []);
  return (
    <>
      <div className='container-location'>
        {/* <img src={imgDivider} alt='' srcset='' /> */}
        <div className='box-title-location'>
          <p className='title-location'>
            <span className='font-border'>OK,,</span> WHERE IS
          </p>
          <p className='title-location'>
            OUR <span className='font-border'>LOCATION??</span>
          </p>
        </div>
      </div>

      <div className='col-maps'>
        <div className='box-maps'>
          <iframe
            src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3965.7800540575495!2d106.88799497593725!3d-6.292611661591425!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f2a18b282177%3A0x5dc950c652b0c4c9!2sJl.%20Mundu%2C%20Lubang%20Buaya%2C%20Kec.%20Cipayung%2C%20Kota%20Jakarta%20Timur%2C%20Daerah%20Khusus%20Ibukota%20Jakarta!5e0!3m2!1sid!2sid!4v1693818278547!5m2!1sid!2sid'
            allowFullScreen=''
            loading='lazy'
            referrerPolicy='no-referrer-when-downgrade'
          ></iframe>
          {/* <img src={CircleSpinner} alt='' srcset='' className="circle-moendoe"/> */}
        </div>
        <div className='container-img-loc' ref={circleRef}>
          <img src={Arrow} alt='' srcSet='' className='img-one-loc' />
        </div>
        <div className='container-img-right-loc' ref={circleRefs}>
          <img src={ArrowSecond} alt='' srcSet='' className='img-two-loc' />
        </div>
      </div>
    </>
  );
};

export default Location;
